import Vue from 'vue'

const roles = {
    USER: 'user_group',
    ADMIN: 'admin_group',
    SALE: 'sale_group',
    MARKETING: 'marketing_group'
}

const env = {
    DEV: 'development',
    STA: 'staging',
    PRO: 'production'
}

const projectType = {
    POSTPAID: 'postpaid',
    PREPAID: 'prepaid'
}

const $const = {
    roles: roles,
    env: env,
    projectType: projectType,
    LIMIT_USAGE: 'Limit',
    NO_LIMIT_USAGE: 'Unlimit',
    COMPLETED: 'completed',
    ACTIVE: 'active',
    WAITING: 'waiting',
    DRAFT: 'draft',
    CANCELED: 'canceled',
    TOKEN_KEY: 'jwToken',
    REFRESH_TOKEN_KEY: 'jwTokenRefresh',
    LOGIN_METHOD_KEY: 'ai_loginMethod',
    MAX_PROJECTS: 3,
    DATE_FORMAT: 'YYYY-MM-DD',
    MONTH_FORMAT: 'YYYY-MM',
    LANGUAGE: 'language'
}

Vue.prototype.$const = $const

export default $const
